import { stripCnpjMask } from './onlyNumbers';

const cnpj = function (value) {
  const data = stripCnpjMask(value);
  if (!data || data.length < 14) {
    return '';
  }
  return `${data.slice(0, 2)}.${data.slice(2, 5)}.${data.slice(5, 8)}/${data.slice(8, 12)}-${data.slice(12, 14)}`;
};

export { cnpj };
